/**
 * 
 * @param {string} value 
 * @returns {string}
 */
export function formatNumber(value) {
    const number = parseFloat(value);
    if (isNaN(number)) {
        return '0';
    }
    return number.toLocaleString('es-AR', { maximumFractionDigits: 1 });
}

/**
 * Animate statistics counter
 * @param {string} selector - CSS selector for the element to animate
 */
export function animateStatistics(selector) {
    const target = parseFloat($(selector).data('val'));
    const display = $(selector);
    let current = 0;
    const increment = Math.abs(target) / 50;

    const updateCount = () => {
        current += increment;
        if (current >= Math.abs(target)) {
            current = Math.abs(target);
            clearInterval(counter);
        }
        const hasPercent = display.text().includes('%');
        const suffix = hasPercent ? '%' : '';
        const prefix = hasPercent ? (target > 0 ? '+' : '-') : '';
        display.text(prefix + formatNumber(String(current)) + suffix);
    };

    const counter = setInterval(updateCount, 20);
}

/**
 * Animate statistics when element becomes visible
 * @param {string} selector - CSS selector for the element to animate
 */
export function animateStatisticsWhenVisible(selector) {
    const element = $(selector);
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateStatistics(selector);
                observer.unobserve(entry.target);
            }
        });
    });
    if (element[0] instanceof Element) {
        observer.observe(element[0]);
    }
}